/**
 * Wholesale Mix & Match Controller
 * Handles quantity selection and enforces minimum order quantity
 */

class WholesaleMixMatch {
  constructor() {
    this.minBottles = 6;  // Minimum order quantity
    this.items = [];
    this.init();
  }

  init() {
    this.setupQuantityControls();
    this.setupCheckoutButton();
    this.updateCounter();
  }

  setupQuantityControls() {
    // Handle +/- buttons
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const action = btn.dataset.action;
        const input = btn.closest('.quantity-input').querySelector('.qty-input');
        let value = parseInt(input.value) || 0;

        if (action === 'plus') {
          value = Math.min(value + 1, parseInt(input.max));
        } else if (action === 'minus') {
          value = Math.max(value - 1, 0);
        }

        input.value = value;
        input.dispatchEvent(new Event('change'));
      });
    });

    // Handle direct input changes
    document.querySelectorAll('.qty-input').forEach(input => {
      input.addEventListener('change', () => {
        let value = parseInt(input.value) || 0;
        value = Math.max(0, Math.min(value, parseInt(input.max)));
        input.value = value;

        // Add visual indicator
        const card = input.closest('.wholesale-card');
        if (value > 0) {
          card.classList.add('has-quantity');
        } else {
          card.classList.remove('has-quantity');
        }

        this.updateCounter();
      });
    });
  }

  setupCheckoutButton() {
    const btn = document.getElementById('wholesaleCheckout');
    if (!btn) return;

    btn.addEventListener('click', () => {
      if (this.getTotalBottles() >= this.minBottles) {
        this.addAllToCart();
      }
    });
  }

  getTotalBottles() {
    let total = 0;
    document.querySelectorAll('.qty-input').forEach(input => {
      total += parseInt(input.value) || 0;
    });
    return total;
  }

  updateCounter() {
    const total = this.getTotalBottles();
    const remaining = Math.max(0, this.minBottles - total);

    // Update counter display
    const countEl = document.getElementById('wholesaleCount');
    const remainingEl = document.getElementById('wholesaleRemaining');

    if (countEl) {
      countEl.textContent = total;
    }

    if (remainingEl) {
      if (total >= this.minBottles) {
        remainingEl.textContent = ` / ${this.minBottles} minimum ✓`;
        remainingEl.style.color = '#ECFCCB';
      } else {
        remainingEl.textContent = ` / ${this.minBottles} minimum (${remaining} more needed)`;
        remainingEl.style.color = 'white';
      }
    }

    // Update checkout button
    this.updateCheckoutButton(total);
  }

  updateCheckoutButton(total) {
    const btn = document.getElementById('wholesaleCheckout');
    const subtext = document.getElementById('checkoutSubtext');

    if (!btn) return;

    if (total >= this.minBottles) {
      btn.disabled = false;
      btn.classList.add('ready');
      if (subtext) {
        subtext.textContent = `Ready to add ${total} bottle${total !== 1 ? 's' : ''} to cart!`;
      }
    } else {
      btn.disabled = true;
      btn.classList.remove('ready');
      const remaining = this.minBottles - total;
      if (subtext) {
        subtext.textContent = `Add ${remaining} more bottle${remaining !== 1 ? 's' : ''} to continue`;
      }
    }
  }

  async addAllToCart() {
    const items = [];

    // Collect all items with quantities
    document.querySelectorAll('.qty-input').forEach(input => {
      const qty = parseInt(input.value) || 0;
      if (qty > 0) {
        items.push({
          id: input.dataset.variantId,
          quantity: qty
        });
      }
    });

    if (items.length === 0) {
      return;
    }

    // Show loading state
    const btn = document.getElementById('wholesaleCheckout');
    const originalText = btn.innerHTML;
    btn.innerHTML = '<span class="button-text">Adding to cart...</span>';
    btn.disabled = true;

    try {
      // Add items to cart using Shopify's Cart API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }

      // Success! Redirect to cart
      window.location.href = '/cart';

    } catch (error) {
      console.error('Error adding to cart:', error);

      // Show error message
      btn.innerHTML = '<span class="button-text">Error - Please try again</span>';

      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 2000);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new WholesaleMixMatch();
  });
} else {
  new WholesaleMixMatch();
}
